import {v4 as uuidv4} from 'uuid';
import {
  ADD_FIELD,
  ADD_FOLDER,
  ADD_FOLDER_TABLE,
  ADD_MDM_VIEW,
  ADD_MODULE,
  ADD_NEW_ROW_IN_TABLE,
  BULK_UPDATE_CHECKS_SET,
  BULK_UPDATE_CHECKS_UNSET,
  DELETE_FIELD,
  DELETE_FOLDER,
  DELETE_IMPORT_ROW,
  DELETE_MDM_VIEW,
  DELETE_MODULE,
  DELETE_TABLE,
  GET_PERMISSIONS_BY_OBJECT,
  GET_TABLE_DATA,
  GET_TODO_USER_LIST,
  HIDE_CREATE_FILTER_MODAL,
  HIDE_CREATE_RECORD_MODAL,
  HIDE_DATA_MANAGEMENT_MODAL,
  HIDE_FIELD_MODAL,
  HIDE_FOLDER_MODAL,
  HIDE_IMPORT_MODAL,
  HIDE_IMPORT_TABLE_VIEW_MODAL,
  HIDE_MODULE_MODAL,
  HIDE_PERMISSIONS_MODAL,
  HIDE_TODO_LIST_MODAL,
  HIDE_VIEW_RECORD_MODAL,
  INSERT_ITEM_IN_SCHEMA,
  MDM_VIEW_MARK_DEFAULT,
  PROCESS_PROGRESS_BAR,
  SELECT_MDM_VIEW,
  SET_ALL_FIELDS,
  SET_BUILDER_LOADING,
  SET_CURRENT_FOLDER,
  SET_EDIT_FILTER_MODAL_LOADING,
  SET_EDIT_MODAL_LOADING,
  SET_FIELD_DATA,
  SET_FIELD_DATA_LOADING,
  SET_FIELDS,
  SET_FOLDER_DATA,
  SET_FOLDER_DATA_LOADING,
  SET_FOLDER_DATA_PERMISSIONS,
  SET_FOLDER_LIST,
  SET_FOLDER_LIST_LOADING,
  SET_FOLDER_LIST_MODULE,
  SET_FOLDERS_DATA,
  SET_LOADING,
  SET_MODAL_FIELDS,
  SET_MODAL_LOADING,
  SET_MODULE_DATA,
  SET_MODULE_DATA_LOADING,
  SET_MODULE_DATA_PERMISSIONS,
  SET_MODULE_LIST,
  SET_MODULE_LIST_LOADING,
  SET_MODULE_MODAL_LOADING,
  SET_ORCHESTRATION,
  SET_ORCHESTRATION_LOADING,
  SET_PAGEDDATA_LOOKUP_VALUES_LOADING,
  UPDATE_TODO_LIST_CONFIG,
  SET_POWER_APPS_ENTITY,
  SET_POWER_BI_REPORT_ENTITY,
  SET_RECYCLE_BIN_DATA,
  SET_RECYCLE_BIN_LOADING,
  SET_TABLE_CONVERT_MAP,
  SET_TABLE_DATA,
  SET_TABLE_DATA_LOADING,
  SET_TABLE_DATA_PERMISSIONS,
  SET_TABLE_FIELDS,
  SET_TABLE_ROW,
  SET_TABLE_SCHEMA,
  SET_TABLE_TOGGLE_COLUMNS,
  SET_TABLE_VIEW_LOADING,
  SET_TABLE_VIEW_SCHEMA,
  SET_TABLES,
  SET_VIEW_RECORD_MODAL_DATA,
  SHOW_CREATE_FILTER_MODAL,
  SHOW_CREATE_RECORD_MODAL,
  SHOW_DATA_MANAGEMENT_MODAL,
  SHOW_FIELD_MODAL,
  SHOW_FOLDER_MODAL,
  SHOW_IMPORT_MODAL,
  SHOW_IMPORT_TABLE_VIEW_MODAL,
  SHOW_MODULE_MODAL,
  SHOW_PERMISSIONS_MODAL,
  SHOW_TODO_LIST_MODAL,
  SHOW_VIEW_RECORD_MODAL,
  TOGGLE_DATA_MANAGEMENT_MODAL,
  TOGGLE_TABLE_VIEW_MODAL_LOADING,
  TOGGLE_TODO_LIST_TABLE_LOADING,
  TOGGLE_VIEW_RECORD_MODAL,
  UNSET_FOLDER_LIST,
  UNSET_MODULE_LIST,
  UPDATE_FIELD,
  UPDATE_FIELD_POSITION,
  UPDATE_FOLDER,
  UPDATE_FOLDER_TABLE,
  UPDATE_IMPORT_LOOKUP_OPTION,
  UPDATE_IMPORT_REVIEW,
  UPDATE_IMPORT_TABLE_VIEW_MODAL_ITEMS,
  UPDATE_LOOKUP_OPTION,
  UPDATE_MDM_VIEW,
  UPDATE_MODULE,
  UPDATE_PAGINATION,
  UPDATE_PAGINATION_PARAMS,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_ITEMS,
  OPEN_CONTEXT_MENU,
  CLOSE_CONTEXT_MENU,
  SET_LOOKUP_VALUES,
  UPDATE_FUZZY_LIST,
  CREATE_FUZZY_CONFIG,
  REMOVE_ELEMENT_FROM_FUZZY_LIST,
  ADD_KEYS_FOR_FUZZY_CONFIG_ITEMS,
  REMOVE_CONFIG_IF_FUZZY_DID_NOT_SELECTED,
  TRANSFORM_FUZZY_CONFIG,
  RESET_DEFAULT_OPTIONS,
  FIELD_OPTIONS,
  RESET_TABLE_DATA,
  SET_DEFAULT_LOOKUP_VALUES,
  ADD_SELECTED_VALUE_TO_DEFAULT_FIELDS,
  ADD_MULTISELECT_REFS_TO_STORE,
  UPDATE_CALCULATIONS,
  UPDATE_TABLE_FIELD_IS_CALCULATED_STATE,
  SET_FIELD_ITEM_CALCULATION_LOADING_STATE,
  SET_UPLOAD_HISTORY_LOADING,
  SET_UPLOAD_HISTORY_DATA,
  UPDATE_UPLOAD_HISTORY_PAGINATION,
  UPDATE_FULL_UPLOAD_DATA,
} from './mutation-types';
import {getFieldInitialData} from './state';
import {transformLookupValues} from '@/core/utils/transformLookupValues';

export default {

  /**
     *
     * @param { DataManagementState } state
     * @param { Table[] } folders
     */
  [SET_FOLDER_LIST](state, folders) {
    state.folders.loaded = true;
    state.folders.data = folders;
  },
  [SET_FOLDER_LIST_MODULE](state, module) {
    state.folders.module = module;
  },
  [SET_MODULE_LIST](state, modules) {
    state.modules.loaded = true;
    state.modules.data = modules;
  },
  [UNSET_FOLDER_LIST](state) {
    state.folders.loaded = false;
    state.folders.data = [];
  },
  [UNSET_MODULE_LIST](state) {
    state.modules.loaded = false;
    state.modules.data = [];
  },
  [SET_FOLDER_LIST_LOADING](state, loading) {
    state.folders.loading = loading;
  },
  [SET_MODULE_LIST_LOADING](state, loading) {
    state.modules.loading = loading;
  },
  [SET_TABLE_SCHEMA](state, tableSchema) {
    state.builder.schema = tableSchema;
    state.table.schema.fields = tableSchema.fields;
  },
  [SET_TABLE_TOGGLE_COLUMNS](state, toggleColumns) {
    state.table.schema.toggleColumns = toggleColumns;
  },
  [UPDATE_TABLE_DATA](state, {data, pagination}) {
    state.table.data = data;
    if (pagination) {
      state.table.pagination = pagination;
    }
  },
  [SET_TABLE_VIEW_SCHEMA](state, table) {
    state.table.schema = {
      ...state.table.schema,
      ...{
        description: table.description,
        fields: table.fields,
        toggleColumns: table.toggleColumns,
        filter: table.filter,
        currentUserPermissionLevel: table.currentUserPermissionLevel,
        name: table.name,
        displayName: table.displayName,
        postedStatusGuid: table.postedStatusMDMFieldGuid,
        folder: table.folder,
      },
    };
    state.table.views = [{viewName: 'Default', viewGuid: ''}, ...table.views.map(v => {
      v.entityGuid = table.entityGuid;
      return v;
    })];
    state.table.data = table.data;
    state.table.pagination.total = table.total;
    state.table.validationRules = table.validationRules;
  },
  [ADD_MDM_VIEW](state, view) {
    state.table.views = [
      ...state.table.views,
      view,
    ];
  },
  [UPDATE_MDM_VIEW](state, view) {
    state.table.views = state.table.views.map(v => {
      if (view.viewGuid === v.viewGuid) {
        return view;
      }
      return v;
    });
  },
  [SELECT_MDM_VIEW](state, guid) {
    state.table.views = state.table.views.map(v => {
      if (!guid && !v.viewGuid || guid === v.viewGuid) {
        v.isSelected = true;
        return v;
      }
      v.isSelected = false;
      return v;
    });
  },
  [DELETE_MDM_VIEW](state, guid) {
    state.table.views = state.table.views.filter(v => v.viewGuid !== guid);
  },
  [MDM_VIEW_MARK_DEFAULT](state, view) {
    state.table.views = state.table.views.map(v => {
      if (view.viewGuid === v.viewGuid) {
        return {
          ...v,
          isDefault: true,
        };
      }
      v.isDefault = false;
      return v;
    });
  },
  [SET_TABLE_FIELDS](state, data) {
    state.table.schema.fields = data;
  },
  [BULK_UPDATE_CHECKS_SET](state, params) {
    if (params.type) {
      state.table.checkedItems = [...params.data];
      return state.table.checkedAll = true;
    } else {
      state.table.checkedItems.push(params.data);
    }
    state.table.checkedAll = state.table.checkedItems.length === params.totalRows;
  },
  [BULK_UPDATE_CHECKS_UNSET](state, params) {
    if (params.type) {
      state.table.checkedItems = [];
      state.table.checkedAll = false;
    } else {
      state.table.checkedItems = state.table.checkedItems.filter(i => i[params.primaryKeyName] !== params.itemGuid);
      state.table.checkedAll = state.table.checkedItems.length === params.totalRows;
    }
  },
  [INSERT_ITEM_IN_SCHEMA](state, item) {
    const primaryField = state.table.schema.fields.find((f) => f.isPrimaryKey);
    const itemIndex = state.table.data.findIndex((elem) => elem[primaryField.name] === item[primaryField.name]);
    if (itemIndex > -1) {
      const changedArray = [...state.table.data];
      changedArray[itemIndex] = item;
      state.table.data = [...changedArray];
    } else {
      state.table.data.push(item);
      state.table.pagination.total++;
    }

  },
  [SET_TABLE_VIEW_LOADING](state, loading) {
    state.table.loading = loading;
  },
  [ADD_NEW_ROW_IN_TABLE](state, row) {
    state.table.data.push(row);
  },
  [SET_TABLE_ROW](state, row) {
    state.table.row = row;
  },
  [SHOW_FIELD_MODAL](state, field) {
    state.builder.tableFieldModal.show = true;
    state.builder.tableFieldModal.data = field;
  },
  [HIDE_FIELD_MODAL](state) {
    state.builder.tableFieldModal.show = false;
    state.builder.tableFieldModal.data = {};
  },
  [ADD_FIELD](state) {
    const field = getFieldInitialData();
    field.id = uuidv4();
    state.builder.schema.fields.push(field);
    state.builder.tableFieldModal.data = {};
  },
  [UPDATE_FIELD](state, field) {
    const fieldIndex = state.builder.schema.fields.findIndex(f => f.fieldGuid === field.fieldGuid);
    state.builder.schema.fields[fieldIndex] = field;
    state.builder.schema.fields = [...state.builder.schema.fields];
  },
  [UPDATE_FIELD_POSITION](state, {field, position}) {
    const fieldIndex = state.builder.schema.fields.findIndex(f => f.fieldGuid === field.fieldGuid);
    const [f] = state.builder.schema.fields.splice(fieldIndex, 1);
    state.builder.schema.fields.splice(position, 0, f);
    state.builder.schema.fields = [...state.builder.schema.fields];
  },
  [DELETE_FIELD](state, field) {
    const fieldIndex = state.builder.schema.fields.findIndex(f => f.fieldGuid === field.fieldGuid);
    state.builder.schema.fields.splice(fieldIndex, 1);
    state.builder.schema.fields = [...state.builder.schema.fields];
  },


  [SHOW_CREATE_RECORD_MODAL](state, data) {
    state.table.relationalModals[uuidv4()] = {
      show: true,
      loading: false,
      data: data.record,
      isBulkEditModal: data.isBulkEditModal || false,
      inline: data.inline,
      todo: data.todo || false,
      parentKey: data.parentKey || null,
      parentData: data.parentData || {},
      filters: data.filters || null,
      relationalTableId: data.relationalTableId,
      rowIndex: data.rowIndex,
      field: data.field,
      recordUuid: data.recordUuid,
      entityUuid: data.entityUuid,
      defaultLookupValue: data.defaultLookupValue,
    };
    state.table.relationalModals = {...state.table.relationalModals};
  },
  [SET_MODAL_FIELDS](state, {modalKey, fields}) {
    state.table.relationalModals[modalKey].fields = fields;
    state.table.relationalModals = {...state.table.relationalModals};
  },
  [HIDE_CREATE_RECORD_MODAL](state, modalKey) {
    delete state.table.relationalModals[modalKey];
    state.table.relationalModals = {...state.table.relationalModals};
    state.contextMenu = {
      isContextMenuOpen: false,
      contextMenuItemId: null,
    };
  },
  [SHOW_CREATE_FILTER_MODAL](state, filter) {
    state.table.createFilterEditModal.show = true;
    state.table.createFilterEditModal.data = filter;
  },
  [HIDE_CREATE_FILTER_MODAL](state) {
    state.table.createFilterEditModal.show = false;
    state.table.createFilterEditModal.data = {};
  },
  [SET_EDIT_MODAL_LOADING](state, {modalKey, loading}) {
    state.table.relationalModals[modalKey].loading = loading;
  },
  [UPDATE_LOOKUP_OPTION](state, params) {
    const {parentData, parentKey, fieldName, newOption} = params;

    state.table.relationalModals[parentKey].data = {
      ...state.table.relationalModals[parentKey].data,
      ...parentData,
      [fieldName]: newOption,
    };

    state.table.relationalModals = {...state.table.relationalModals};
  },
  [SET_EDIT_FILTER_MODAL_LOADING](state, loading) {
    state.table.createFilterEditModal.loading = loading;
  },
  [SHOW_FOLDER_MODAL](state, {data}) {
    state.folderModal.data = data;
    state.folderModal.show = true;
  },
  [SHOW_MODULE_MODAL](state, {data}) {
    state.moduleModal.data = data;
    state.moduleModal.show = true;
  },
  [SHOW_PERMISSIONS_MODAL](state, {data}) {
    state.permissionsModal.data = data;
    state.permissionsModal.show = true;
  },
  [HIDE_FOLDER_MODAL](state) {
    state.folderModal.show = false;
    state.folderModal.data = null;
  },
  [HIDE_MODULE_MODAL](state) {
    state.moduleModal.show = false;
    state.moduleModal.data = null;
  },
  [HIDE_PERMISSIONS_MODAL](state) {
    state.permissionsModal.show = false;
    state.permissionsModal.data = {};
  },
  [SET_MODAL_LOADING](state, loading) {
    state.folderModal.loading = loading;
  },

  [SET_MODULE_MODAL_LOADING](state, loading) {
    state.moduleModal.loading = loading;
  },
  [ADD_FOLDER](state, {data}) {
    state.folders.data = [...state.folders.data, data];
    state.allFolders = [...state.allFolders, data];
  },
  [ADD_FOLDER_TABLE](state, {data}) {
    state.folders.data.find(f => f.folderGuid === data.folderGuid).tables.push(data);
    state.tables.data.push(data);
  },
  [ADD_MODULE](state, {data}) {
    state.modules.data = [...state.modules.data, data];
  },
  [UPDATE_FOLDER](state, {data}) {
    const index = state.folders.data.findIndex(f => f.uuid === data.uuid);
    state.folders.data[index] = data;
    state.folders.data = [...state.folders.data];

    const folderIndex = state.allFolders.findIndex(f => f.folderGuid === data.folderGuid);
    state.allFolders[folderIndex] = data;
    state.allFolders = [...state.allFolders];
  },
  // [UPDATE_FOLDER_TABLE](state, {data}) {
  //
  //   const folderIndex = state.folders.data.findIndex(f => f.folderGuid === data.folderGuid);
  //   // const tableIndex = state.folders.data[folderIndex].tables.findIndex(t => t.entityGuid === data.entityGuid)
  //   // state.folders.data[folderIndex].tables[tableIndex] = data;
  //   // state.folders.data = [...state.folders.data];
  //   //
  //   // let index = state.tables.data.findIndex(t => t.entityGuid === data.entityGuid)
  //   // state.tables.data[index] = data;
  //   // state.tables.data = [...state.tables.data];
  // },
  [UPDATE_MODULE](state, {data}) {
    const index = state.modules.data.findIndex(m => m.uuid === data.uuid);
    state.modules.data[index] = data;
    state.modules.data = [...state.modules.data];
  },
  [DELETE_FOLDER](state, data) {
    const folders = [...state.folders.data];
    const removeIndex = folders.map(function (item) {
      return item.folderGuid;
    }).indexOf(data.folderGuid);
    state.folders.data.splice(removeIndex, 1);

    // Delete folder from all folder state
    const index = state.allFolders.findIndex(f => f.folderGuid === data.folderGuid);
    state.allFolders.splice(index, 1);
  },
  [DELETE_MODULE](state, data) {
    const modules = [...state.modules.data];
    const removeIndex = modules.map(function (item) {
      return item.moduleGuid;
    }).indexOf(data.moduleGuid);
    state.modules.data.splice(removeIndex, 1);
  },
  [DELETE_TABLE](state, data) {
    if (state.folders.data.length > 0) {
      const folders = [...state.folders.data];
      const folderIndex = folders.map(function (item) {
        return item.uuid;
      }).indexOf(data.folderUuid);
      const removeIndex = folders[folderIndex].tables.map(function (item) {
        return item.name;
      }).indexOf(data.name);
      state.folders.data[folderIndex].tables.splice(removeIndex, 1);
    }
  },
  [UPDATE_PAGINATION](state, {data}) {
    state.table.pagination = {...state.table.pagination, ...data};
  },

  [SET_TABLE_CONVERT_MAP](state, data) {
    state.convertMap = data;
  },
  [SET_FOLDER_DATA_LOADING](state, loading) {
    state.folderData.loading = loading;
  },
  [SET_FOLDER_DATA](state, folderData) {
    state.folderData.data = folderData;
  },
  [SET_FOLDERS_DATA](state, folderData) {
    state.allFolders = folderData;
  },
  [SET_FOLDER_DATA_PERMISSIONS](state, permissions) {
    state.folderData.data = {...state.folderData.data, permissions};
  },
  [SET_MODULE_DATA_LOADING](state, loading) {
    state.moduleData.loading = loading;
  },
  [SET_MODULE_DATA](state, moduleData) {
    state.moduleData.data = moduleData;
  },
  [SET_MODULE_DATA_PERMISSIONS](state, permissions) {
    state.moduleData.data = {...state.moduleData.data, permissions};
  },
  [SET_TABLE_DATA_LOADING](state, loading) {
    state.tableData.loading = loading;
  },
  [SET_TABLE_DATA](state, tableData) {
    state.tableData.data = tableData;
  },
  [SET_TABLE_DATA_PERMISSIONS](state, permissions) {
    state.tableData.data = {...state.tableData.data, permissions};
  },
  [SET_FIELD_DATA_LOADING](state, loading) {
    state.fieldData.loading = loading;
  },
  [SET_FIELD_DATA](state, permissions) {
    state.fieldData.data = permissions;
  },
  [SET_TABLES](state, {data}) {
    state.tables.data = data;
    state.tables.loaded = true;
  },
  [SET_BUILDER_LOADING](state, loading) {
    state.builder.loading = loading;
  },
  [SET_RECYCLE_BIN_LOADING](state, loading) {
    state.recycleBin.loading = loading;
  },
  [SET_RECYCLE_BIN_DATA](state, data) {
    state.recycleBin.data = data;
  },
  [SET_FIELDS](state, {data}) {
    state.fields.data = data;
    state.fields.loaded = true;
  },
  [SHOW_VIEW_RECORD_MODAL](state) {
    state.table.viewModal.show = true;
  },
  [SET_VIEW_RECORD_MODAL_DATA](state, data) {
    state.table.viewModal.data = data;
  },
  [HIDE_VIEW_RECORD_MODAL](state) {
    state.table.viewModal.show = false;
    state.table.viewModal.data = [];
    state.contextMenu = {
      isContextMenuOpen: false,
      contextMenuItemId: null,
    };
  },
  [TOGGLE_VIEW_RECORD_MODAL](state, loading) {
    state.table.viewModal.loading = loading;
  },
  [SHOW_IMPORT_MODAL]: state => state.table.importModal.show = true,
  [HIDE_IMPORT_MODAL]: state => state.table.importModal.show = false,
  [SHOW_IMPORT_TABLE_VIEW_MODAL](state, data) {
    state.table.importTableViewModal.show = true;
    state.table.importModal.show = false;
    state.table.importTableViewModal.items = data.tableItems;
    state.table.importTableViewModal.fieldDataMap = data.fieldDataMap;
    state.table.importTableViewModal.itemCountWithDecimalPlacesExceeded = data.itemCountWithDecimalPlacesExceeded;
  },
  [UPDATE_IMPORT_TABLE_VIEW_MODAL_ITEMS](state, {item, index}) {
    state.table.importTableViewModal.items[index] = {...item};

    const businessKeyFields = {};
    state.table.schema.fields.forEach(f => {
      if (f.isBusinessKey) businessKeyFields[f.name] = f;
    });

    if (businessKeyFields && Object.keys(businessKeyFields).length) {

      const itemsMapByBusinessKey = new Map();

      const getBusinessKeyForMap = (item) => {
        return Object.entries(item)
          .filter(([key, value]) => businessKeyFields[key])
          .map(([key, value]) => value)
          .join('||');
      };

      const addError = (field, item, message) => {
        item._cellVariants = {...item._cellVariants, [field.name]: 'danger'};
        item.errors = {...item.errors, [field.name]: message};
      };

      const removeError = (field, item) => {
        item._cellVariants = {...item._cellVariants, [field.name]: 'success'};

        item.errors = Object.keys(item.errors).reduce((errors, key) => {
          const hasDuplicatesError = item.errors[key].indexOf('Duplicate') > -1;

          if (hasDuplicatesError) return errors;

          errors[field.name] = item.errors[key];

          return errors;
        }, {});
      };

      const isFieldLookup = field => field.dataTypeName === 'lookup';

      const markBusinessKeyFieldsAsErrored = (item) => {
        for (const fieldName in businessKeyFields) {
          const f = businessKeyFields[fieldName];

          let titleToShow = item[f.name];
          if (isFieldLookup(f)) {
            const lookupItem = f.data.options.find(o => o.id === titleToShow);
            if (lookupItem) titleToShow = lookupItem.text;
          }

          addError(f, item, `Duplicate business key of ${titleToShow}`);
        }
        return item;
      };

      const removeErrorsFromBusinessKeyFields = (item) => {
        for (const fieldName in businessKeyFields) {
          const field = businessKeyFields[fieldName];
          removeError(field, item);
        }
        return item;
      };

      let items = state.table.importTableViewModal.items;

      items = items.map((i, idx) => {

        const hasDuplicatesError = i.errors && Object.keys(i.errors)
          .find(key => i.errors[key].indexOf('Duplicate') > -1);
        if (hasDuplicatesError) removeErrorsFromBusinessKeyFields(i);

        const businessKeyForMap = getBusinessKeyForMap(i);
        if (itemsMapByBusinessKey.has(businessKeyForMap)) {
          // Detected duplicates
          const [idx, firstItem] = itemsMapByBusinessKey.get(businessKeyForMap);
          markBusinessKeyFieldsAsErrored(firstItem);
          items[idx].options = items[idx].options || {};
          markBusinessKeyFieldsAsErrored(i);
        } else {
          itemsMapByBusinessKey.set(businessKeyForMap, [idx, i]);
        }

        return i;
      });
    }
  },
  [UPDATE_IMPORT_REVIEW](state, data) {
    state.table.importTableViewModal.items = [...data];
  },
  [UPDATE_IMPORT_LOOKUP_OPTION](state, {field, option}) {
    state.table.importTableViewModal.items = state.table.importTableViewModal.items.map(item => {
      if (item.options && Object.keys(item.options).length) {
        item.options[field.name].matchStrings.push(option);
      }
      return item;
    });
  },
  [HIDE_IMPORT_TABLE_VIEW_MODAL](state) {
    state.table.importTableViewModal.show = false;
    state.table.importTableViewModal.items = [];
  },
  [TOGGLE_TABLE_VIEW_MODAL_LOADING](state, loading) {
    state.table.importTableViewModal.loading = loading;
  },
  [DELETE_IMPORT_ROW](state, index) {
    state.table.importTableViewModal.items[index].isVisible = false;
  },
  [GET_TABLE_DATA](state, data) {
    state.todoList.table.data = data;
  },
  [TOGGLE_TODO_LIST_TABLE_LOADING](state, loading) {
    state.todoList.table.loading = loading;
  },
  [GET_TODO_USER_LIST](state, data) {
    state.todoList.table.userData = [...data];
  },
  [GET_PERMISSIONS_BY_OBJECT](state, data) {
    state.permissionObjectData = [...data];
  },
  [SHOW_DATA_MANAGEMENT_MODAL](state, param) {
    state.dataManagementModal.show = param;
  },
  [HIDE_DATA_MANAGEMENT_MODAL](state) {
    state.dataManagementModal.show = false;
  },
  [TOGGLE_DATA_MANAGEMENT_MODAL](state, param) {
    state.dataManagementModal.loading = param;
  },
  [PROCESS_PROGRESS_BAR](state, params) {
    if (params.process) state.progressBar.process += params.process;
    if (params.target) state.progressBar.target = params.target;

    if (state.progressBar.process >= state.progressBar.target) {
      state.progressBar.process = 0;
      state.progressBar.target = 0;
    }
  },
  [UPDATE_PAGINATION_PARAMS](state, params) {
    state.table.pagination = {...params};
  },
  [UPDATE_TABLE_ITEMS](state, params) {
    const updatedItemMap = new Map();
    params.updatedItems.forEach(item => updatedItemMap.set(item[params.primaryKey], item));

    state.table.data = state.table.data.map(item => updatedItemMap.get(item[params.primaryKey]) || item);
  },
  [SET_POWER_APPS_ENTITY](state, entity) {
    state.powerAppsEntity = entity;
  },
  [SET_POWER_BI_REPORT_ENTITY](state, entity) {
    state.powerBiReportEntity = entity;
  },
  [SHOW_TODO_LIST_MODAL](state, data) {
    state.todoListModal.data = data;
    state.todoListModal.show = true;
  },
  [HIDE_TODO_LIST_MODAL](state) {
    state.todoListModal.data = {};
    state.todoListModal.show = false;
  },
  [SET_LOADING](state, payload) {
    state.loading = payload;
  },
  [SET_PAGEDDATA_LOOKUP_VALUES_LOADING](state, payload) {
    state.pagedDataLookupValuesLoading = payload;
  },
  [SET_ALL_FIELDS](state, payload) {
    state.allFields = payload;
  },
  [SET_CURRENT_FOLDER](state, payload) {
    state.currentFolder = payload;
  },
  [SET_ORCHESTRATION](state, payload) {
    state.orchestration.data = payload.data;
  },
  [SET_ORCHESTRATION_LOADING](state, payload) {
    state.orchestration.loaded = payload;
  },
  [UPDATE_TODO_LIST_CONFIG](state, payload) {
    state.builder.schema.toDoListConfig = payload;
  },
  [OPEN_CONTEXT_MENU](state, payload) {
    state.contextMenu = {
      isContextMenuOpen: true,
      contextMenuItemId: payload,
    };
  },
  [CLOSE_CONTEXT_MENU](state) {
    state.contextMenu = {
      isContextMenuOpen: false,
      contextMenuItemId: null,
    };
  },
  [ADD_SELECTED_VALUE_TO_DEFAULT_FIELDS](state, payload){
    if(state.pagedDataLookups) {
      const isItemAlreadyExist = state.pagedDataLookups.some(el => el.id === payload.id);
      !isItemAlreadyExist && state.pagedDataLookups.push(payload);
    } else {
      state.pagedDataLookups = [payload];
    }
  },
  [SET_LOOKUP_VALUES](state, payload) {
    const {fieldGuid, options} = payload;
    state.lookupValues[fieldGuid] = options;
  },
  [RESET_DEFAULT_OPTIONS] (state, payload) {
    //todo: check this block of code (related to lkps refactoring)
    // state.table.schema.fields = state.table.schema.fields.map(el => {
    //   if(el.fieldGuid === payload) {
    //     // el.data.options = el.data.options.slice(0, 50);
    //     return el;
    //   }
    //   return el;
    // });
    // state.defaultOptions = null;
  },
  [UPDATE_FUZZY_LIST](state, payload) {
    state.builder.tableFieldModal.data.dataTypeJSON.FuzzyMatchConfig.FieldConfigs.push(payload);
  },
  [CREATE_FUZZY_CONFIG](state) {
    state.builder.tableFieldModal.data.dataTypeJSON = {
      ...state.builder.tableFieldModal.data.dataTypeJSON,
      OrderOfCalculation: 0,
      FuzzyMatchConfig: {
        TopXSuggestions: 5,
        MatchThreshold: 75,
        AutoMatchThreshold: 100,
        FieldConfigs: [],
        RecalculateWhenSourceDataChanges: false,
      },
    };
  },
  [REMOVE_ELEMENT_FROM_FUZZY_LIST](state, payload) {
    state.builder.tableFieldModal.data.dataTypeJSON.FuzzyMatchConfig.FieldConfigs =  state.builder.tableFieldModal.data.dataTypeJSON.FuzzyMatchConfig.FieldConfigs.filter(el =>{
      return  el.key !== payload;
    });
  },
  [ADD_KEYS_FOR_FUZZY_CONFIG_ITEMS](state) {
    const data = state.builder.tableFieldModal.data.dataTypeJSON.FuzzyMatchConfig.FieldConfigs;
    state.builder.tableFieldModal.data.dataTypeJSON.FuzzyMatchConfig.FieldConfigs = data.map(el => ({
      ...el,
      key: uuidv4(),
    }));
  },
  [REMOVE_CONFIG_IF_FUZZY_DID_NOT_SELECTED](state) {
    state.builder.tableFieldModal.data.dataTypeJSON.FuzzyMatchConfig = null;
  },
  [TRANSFORM_FUZZY_CONFIG](state, isOpen) {
    state.builder.tableFieldModal.data.dataTypeJSON.FuzzyMatchConfig.FieldConfigs = state.builder.tableFieldModal.data.dataTypeJSON.FuzzyMatchConfig.FieldConfigs.map(el => {
      return {...el, MatchThreshold: isOpen ? el.MatchThreshold * 100 : el.MatchThreshold / 100};
    });
  },
  [FIELD_OPTIONS](state, payload) {
    state.fieldOptions = payload;
  },
  [RESET_TABLE_DATA](state) {
    state.table.data = [];
  },
  [SET_DEFAULT_LOOKUP_VALUES](state, payload) {
    state.pagedDataLookups = transformLookupValues(payload, true);
  },
  [ADD_MULTISELECT_REFS_TO_STORE](state, payload) {
    state.multiselectRefs[payload.name] = payload.ref;
  },
  [UPDATE_CALCULATIONS](state, payload){
    state.builder.tableFieldModal.data = {
      ...state.builder.tableFieldModal.data,
      calculation: payload,
    };
  },
  [UPDATE_TABLE_FIELD_IS_CALCULATED_STATE](state, payload){
    state.builder.tableFieldModal.data = {
      ...state.builder.tableFieldModal.data,
      isCalculated: payload,
    };
  },
  [SET_FIELD_ITEM_CALCULATION_LOADING_STATE](state, payload) {
    state.fieldItemCalculationLoadingState = payload;
  },
  // Mutations for the view upload history modal
  [SET_UPLOAD_HISTORY_LOADING](state, payload) {
    state.uploadHistory.loading = payload;
  },
  [SET_UPLOAD_HISTORY_DATA](state, payload) {
    state.uploadHistory.data = payload;
  },
  [UPDATE_UPLOAD_HISTORY_PAGINATION](state, payload) {
    state.uploadHistory.page = payload;
  },
  [UPDATE_FULL_UPLOAD_DATA](state, payload) {
    state.uploadHistory.fullUploadData = payload;
  },
};
